import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/ophthalmologist-surgeries/$slug")({
  loader: ({ params }) => loadLegacyContent(`ophthalmologist-surgeries/${params.slug}`),
  head: ({ loaderData, params }) =>
    loaderData
      ? legacyHead(`/ophthalmologist-surgeries/${params.slug}`, loaderData)
      : { meta: [{ title: "Eye Surgery — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
